import {environment} from "@environments/environment";

export class NavigationUtils {

  public static navigateToGwoLoginPage():void {
    window.location.href = environment.loginGwoUrl
  }
}
